import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {
    constructor(public dialog: MatDialog) {}

    confirm(title: string, text: string, confirm = 'Oké', cancel: string | null = null): Promise<any> {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            disableClose: true,
            data: {
                title,
                text,
                confirm,
                cancel,
            },
        });

        return new Promise<void>((resolve, reject) => {
            const subs = dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    resolve();
                } else {
                    reject();
                }
                subs.unsubscribe();
            });
        });
    }
}
